﻿<template>
    <div class="sm-head" v-if="getRef() != '0' && getRef() != null">
        <h5 class="sm-title">Trip summary</h5>
        <button v-if="get_total_price() > 0" type="button" class="sm-toggle" :aria-expanded="isOpen" @click="isOpen = !isOpen" :hidden="display_open">
            {{ isOpen ? 'Hide breakdown' : 'Show breakdown' }}
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" :class="{ 'is-open': isOpen }"><path d="M6 9l6 6 6-6" /></svg>
        </button>
    </div>
    <div class="sm-breakdown" :hidden="display_details()">
        <template v-for="trip in get_Trips()" :key="trip.tour_id">
            <div class="sm-trip" :hidden="!zeroPriceCheck(trip)">
                <div class="sm-row is-head">
                    <span>{{product_name(trip)}}</span>
                    <span v-if="isAAT()" v-html="product_duration(trip)"></span>
                    <span v-else v-html="durationInDays(trip)"></span>
                </div>

                <div class="sm-dates" :class="{ hidden: isAddon(trip) || product_check_dates(trip) }">
                    <template v-if="!isAAT()">
                        <span v-if="product_start_end_date(trip) != ''">{{product_start_end_date(trip)}}</span>
                        <template v-else>
                            <span>Start date: {{product_start_date(trip)}}</span>
                            <span>End date: {{product_end_date(trip)}}</span>
                        </template>
                    </template>
                    <template v-else-if="product_start_end_date(trip) == ''">
                        <span>Start date: {{product_start_date_Only(trip)}}</span>
                        <span>End date: {{product_end_date_only(trip)}}</span>
                    </template>
                </div>

                <div class="sm-row is-line" v-for="(passenger, index) in trip.passengers" :key="index">
                    <span>{{passenger_info(passenger)}}</span>
                    <span>{{passenger_price(passenger)}}</span>
                </div>

                <template v-if="room_breakdown(trip).length > 0">
                    <div class="sm-row is-head is-sub">
                        <span>Accommodation</span>
                        <span v-html="room_total(trip)"></span>
                    </div>
                    <div class="sm-row is-line" v-for="(room, index) in room_breakdown(trip)" :key="'room' + index">
                        <span>{{room.room_type}}</span>
                    </div>
                </template>
            </div>
        </template>

        <div v-if="show_commission()" class="sm-row">
            <span>Nett</span>
            <span>{{ get_total_price_nett_formatted() }}</span>
        </div>
        <div v-if="show_commission()" class="sm-row">
            <span>Commission</span>
            <span>{{ get_total_price_commission_formatted() }}</span>
        </div>
        <div v-if="!hasAddOns()" class="sm-row is-total">
            <span>Total</span>
            <span>{{ get_total_price_formatted() }}</span>
        </div>
    </div>

    <p v-if="getRef() != '0' && getRef() != null && display_open" class="sm-ref">Booking reference <strong>#{{ getRef() }}</strong></p>

</template>

<script lang="ts" src="./itinerary_breakdown.ts"></script>